<div class="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl"
  [class.p-5]="!compact">

  <!-- Input file oculto (compartido por ambos modos) -->
  <input #fileInput type="file" class="hidden" [accept]="accept" (change)="onFileSelected($event)">

  <!-- ======== Header ======== -->
  @if (compact) {
  <!-- Modo compacto (form de edición): cabecera colapsable -->
  <button type="button" (click)="collapsed = !collapsed"
    class="w-full flex items-center justify-between px-5 py-4 group">
    <span class="flex items-center gap-2 text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide group-hover:text-gray-700 dark:group-hover:text-gray-200 transition-colors">
      <svg class="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"/>
      </svg>
      Documentos adjuntos ({{ attachments.length }})
    </span>
    <svg class="w-4 h-4 text-gray-400 transition-transform shrink-0" [class.rotate-180]="!collapsed"
      fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
    </svg>
  </button>
  } @else {
  <!-- Modo completo (detalle): título + botón subir -->
  <div class="flex items-center justify-between gap-3 flex-wrap mb-4">
    <h2 class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide">
      Documentos adjuntos
      @if (attachments.length > 0) {
      <span class="ml-1.5 px-1.5 py-0.5 text-[11px] font-semibold rounded-full bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400 normal-case tracking-normal">
        {{ attachments.length }}
      </span>
      }
    </h2>
    <button type="button" (click)="abrirSelector()" [disabled]="uploading"
      class="flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-lg bg-brand-500 text-white hover:bg-brand-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
      <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"/>
      </svg>
      Subir documento
    </button>
  </div>
  }

  <!-- ======== Cuerpo ======== -->
  @if (!compact || !collapsed) {
  <div [class.px-5]="compact" [class.pb-4]="compact" class="space-y-3">

    <!-- Indicador de subida -->
    @if (uploading) {
    <div class="rounded-lg border border-brand-200 dark:border-brand-800 bg-brand-50 dark:bg-brand-900/15 px-3 py-2.5">
      <div class="flex items-center justify-between gap-3 mb-1.5">
        <span class="text-xs font-medium text-brand-700 dark:text-brand-400 truncate">
          Subiendo "{{ uploadingFileName }}"...
        </span>
        <span class="text-xs text-brand-600 dark:text-brand-400 shrink-0">{{ uploadProgress ?? 0 }}%</span>
      </div>
      <div class="h-1.5 w-full rounded-full bg-brand-100 dark:bg-brand-900/40 overflow-hidden">
        <div class="h-1.5 rounded-full bg-brand-500 transition-all duration-200" [style.width.%]="uploadProgress ?? 0"></div>
      </div>
    </div>
    }

    <!-- Error de subida (validación local o 400 del backend) -->
    @if (uploadError) {
    <div class="flex items-start gap-2 rounded-lg bg-error-50 dark:bg-error-500/10 border border-error-200 dark:border-error-500/20 px-3 py-2">
      <svg class="w-4 h-4 text-error-500 shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
      </svg>
      <p class="text-xs text-error-600 dark:text-error-400">{{ uploadError }}</p>
    </div>
    }

    <!-- Loading -->
    @if (loading) {
    <div class="flex items-center gap-3 py-4 justify-center">
      <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-brand-500"></div>
      <span class="text-sm text-gray-500 dark:text-gray-400">Cargando documentos...</span>
    </div>
    } @else if (loadError) {
    <p class="text-sm text-error-600 dark:text-error-400 py-2">{{ loadError }}</p>
    } @else if (attachments.length === 0 && !uploading) {

    <!-- Estado vacío -->
    @if (compact) {
    <p class="text-xs text-gray-500 dark:text-gray-400">Sin documentos adjuntos.</p>
    } @else {
    <div class="text-center py-6 border-2 border-dashed border-gray-200 dark:border-gray-700 rounded-xl">
      <svg class="w-8 h-8 mx-auto text-gray-300 dark:text-gray-600 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
          d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"/>
      </svg>
      <p class="text-sm text-gray-500 dark:text-gray-400 px-4">
        Sin documentos adjuntos. Sube fichas técnicas, contratos o certificaciones para compartir con el cliente.
      </p>
    </div>
    }

    } @else {

    <!-- Lista de adjuntos -->
    <ul class="space-y-2">
      @for (att of attachments; track att.id) {
      <li class="rounded-lg border border-gray-200 dark:border-gray-700">
        <div class="flex items-center gap-3 px-3 py-2.5">
          <app-quote-attachment-icon [mimeType]="att.mimeType" [fileName]="att.fileName"></app-quote-attachment-icon>

          <!-- Nombre + meta -->
          <div class="flex-1 min-w-0">
            <p class="text-sm font-medium text-gray-800 dark:text-white/90 truncate" [title]="att.fileName">
              {{ att.fileName }}
            </p>
            <p class="text-xs text-gray-500 dark:text-gray-400 truncate">
              {{ formatSize(att.sizeBytes) }}
              @if (!compact && att.uploadedByName) {
              · {{ att.uploadedByName }}
              }
              @if (!compact) {
              · {{ formatDate(att.datetimeCreated) }}
              }
            </p>
          </div>

          <!-- Badge de descargas (clicable si > 0): expande el historial inline -->
          @if (!compact) {
          <button type="button" (click)="toggleHistorial(att)" [disabled]="!att.downloadCount"
            [title]="att.downloadCount ? 'Ver historial de descargas' : 'Aún no se ha descargado'"
            class="shrink-0 inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium rounded-full transition-colors"
            [class]="att.downloadCount
              ? 'bg-brand-50 text-brand-700 hover:bg-brand-100 dark:bg-brand-900/30 dark:text-brand-400 dark:hover:bg-brand-900/50 cursor-pointer'
              : 'bg-gray-100 text-gray-400 dark:bg-gray-800 dark:text-gray-500 cursor-default'">
            <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 10v6m0 0l-3-3m3 3l3-3M3 17v2a2 2 0 002 2h14a2 2 0 002-2v-2"/>
            </svg>
            {{ downloadCountLabel(att) }}
            @if (att.downloadCount) {
            <svg class="w-3 h-3 transition-transform" [class.rotate-180]="expandedHistoryId === att.id"
              fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
            </svg>
            }
          </button>
          }

          <!-- Descargar -->
          <button type="button" (click)="descargar(att)" [disabled]="isDownloading(att)"
            title="Descargar"
            class="shrink-0 p-1.5 rounded-lg text-gray-400 hover:text-brand-600 dark:hover:text-brand-400 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors disabled:opacity-50">
            @if (isDownloading(att)) {
            <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-current"></div>
            } @else {
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 10v6m0 0l-3-3m3 3l3-3M3 17v2a2 2 0 002 2h14a2 2 0 002-2v-2"/>
            </svg>
            }
          </button>

          <!-- Eliminar -->
          <button type="button" (click)="eliminar(att)" [disabled]="isDeleting(att)"
            title="Eliminar"
            class="shrink-0 p-1.5 rounded-lg text-gray-400 hover:text-error-600 dark:hover:text-error-400 hover:bg-error-50 dark:hover:bg-error-500/10 transition-colors disabled:opacity-50">
            @if (isDeleting(att)) {
            <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-current"></div>
            } @else {
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
            </svg>
            }
          </button>
        </div>

        <!-- Historial de descargas inline (solo modo completo) -->
        @if (!compact && expandedHistoryId === att.id) {
        <div class="border-t border-gray-100 dark:border-gray-800 px-3 py-2.5 bg-gray-50 dark:bg-gray-800/40 rounded-b-lg">
          @if (historyLoading) {
          <div class="flex items-center gap-2 py-1.5">
            <div class="animate-spin rounded-full h-3.5 w-3.5 border-b-2 border-brand-500"></div>
            <span class="text-xs text-gray-500 dark:text-gray-400">Cargando historial...</span>
          </div>
          } @else if (historyError) {
          <p class="text-xs text-error-600 dark:text-error-400 py-1">{{ historyError }}</p>
          } @else if (history.length === 0) {
          <p class="text-xs text-gray-500 dark:text-gray-400 py-1">No hay descargas registradas.</p>
          } @else {
          <ul class="divide-y divide-gray-100 dark:divide-gray-800">
            @for (entry of history; track entry.id) {
            <li class="flex items-center justify-between gap-3 py-1.5 flex-wrap">
              <span class="inline-flex items-center gap-1.5 text-xs text-gray-700 dark:text-gray-300 min-w-0">
                <span class="shrink-0 w-1.5 h-1.5 rounded-full"
                  [class]="entry.via === 'PUBLIC' ? 'bg-teal-500' : 'bg-brand-500'"></span>
                <span class="font-medium truncate">{{ viaLabel(entry) }}</span>
              </span>
              <span class="text-xs text-gray-400 dark:text-gray-500 shrink-0">
                {{ formatDateTime(entry.datetimeDownloaded) }}
                @if (entry.ip) {
                · IP {{ entry.ip }}
                }
              </span>
            </li>
            }
          </ul>
          }
        </div>
        }
      </li>
      }
    </ul>
    }

    <!-- Botón subir (modo compacto: al pie de la lista) -->
    @if (compact) {
    <button type="button" (click)="abrirSelector()" [disabled]="uploading"
      class="w-full py-2 text-xs font-medium text-gray-500 dark:text-gray-400 border border-dashed border-gray-300 dark:border-gray-600 rounded-lg hover:border-brand-400 hover:text-brand-500 transition-colors disabled:opacity-50">
      + Subir documento
    </button>
    } @else if (attachments.length > 0) {
    <p class="text-[11px] text-gray-400 dark:text-gray-500">
      Máx. 10 MB por archivo. Los documentos quedan disponibles para el cliente en el portal público.
    </p>
    }
  </div>
  }
</div>
